<template>
  <v-card>
    <Loader v-if="isLoading" />
    <Empty v-else-if="Object.keys(block).length === 0 && block.constructor === Object"/>
    <v-list v-else-if="!isLoading">
      <div class="listContainer">
        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Height:</v-list-tile-title>
          <v-list-tile-content>{{ block.block_meta.header.height }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">TimeStamp:</v-list-tile-title>
          <v-list-tile-content v-if="block.block_meta.header.time">
            <span>
              <span>
                {{ block.block_meta.header.time | moment("utc", "from", "now") }}
              </span>
                ({{ block.block_meta.header.time | moment("utc", "MMM-DD-YYYY HH:mm:ss A") }} +UTC)
            </span>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Transactions:</v-list-tile-title>
            <router-link
              v-if="block.block_meta.header.num_txs > 0"
              class="router-link"
              :to="{
                name: 'blockTransactions',
                params: {
                  blockNumber: block.block_meta.header.height
                }
              }"
            >
              <v-list-tile-content>
                {{
                  `${block.block_meta.header.num_txs} ${block.block_meta.header.num_txs !== 1 ? "txns" :  "txn"}`
                }}
              </v-list-tile-content>
            </router-link>
            <div v-else-if="block.block_meta.header.num_txs <= 0">
               <v-list-tile-content>
                 {{ `${block.block_meta.header.num_txs} ${block.block_meta.header.num_txs !== 1 ? "txns" :  "txn"}` }}
                </v-list-tile-content>
            </div>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Hash:</v-list-tile-title>
          <v-list-tile-content v-if="block.blockEth">
            {{ `${block.blockEth && block.blockEth.hash ? block.blockEth.hash : block.block_meta.block_id.hash}` }}
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Parent Hash:</v-list-tile-title>
           <router-link v-if="block.blockEth && block.blockEth.parentHash" class="router-link" :to="{ name: 'block', params: {blockNumber: block.blockEth.parentHash}}">
               <v-list-tile-content  v-if="block.blockEth && block.blockEth.parentHash" >
                 {{ block.blockEth.parentHash }}
                </v-list-tile-content>
            </router-link>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Size:</v-list-tile-title>
          <v-list-tile-content v-if="block.blockEth && block.blockEth.size >= 0">{{ block.blockEth.size }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Block Award:</v-list-tile-title>
          <v-list-tile-content v-if="block.block.block_reward && block.block.block_reward >= 0">{{ `${block.block.block_reward} CMT` }}</v-list-tile-content>
        </v-list-tile>

        <!-- <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Nonce</v-list-tile-title>
          <v-list-tile-content v-if="block.blockEth && block.blockEth.nonce">{{ block.blockEth.nonce }}</v-list-tile-content>
        </v-list-tile> -->

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Gas Used</v-list-tile-title>
          <v-list-tile-content>{{ block.blockEth && block.blockEth.gasUsed >= 0 ? block.blockEth.gasUsed : '' }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Gas Limit</v-list-tile-title>
          <v-list-tile-content>{{ block.blockEth && block.blockEth.gasLimit >= 0 ? `${block.blockEth.gasLimit} Wei` : '' }}</v-list-tile-content>
        </v-list-tile>
      </div>
    </v-list>
  </v-card>
</template>

<script>
import Loader from '../reusables/loader.vue';
import Empty from '../reusables/empty.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Block',
  props: ['block', 'isLoading'],
  components: {
    Loader,
    Empty,
  },
  computed: {
    ...mapGetters(['totalBlockTransactions']),
  },
};
</script>
